import { Component, Output, EventEmitter, Input, OnInit, signal, computed, OnDestroy, DestroyRef, inject } from '@angular/core';
import { MessageSendConfig, SendMessageReceipients } from 'src/app/models/message';
import { CommService } from '../comm.service';
import { NzTreeNodeOptions } from 'ng-zorro-antd/tree';
import { filter, Subscription } from 'rxjs';
import { NotificationService } from 'src/app/shared/notification.service';

@Component({
  selector: 'app-send-comm',
  templateUrl: './send-comm.component.html',
  styleUrls: ['./send-comm.component.less'],
})

export class SendCommComponent {

  @Output() sendMessageConfig = new EventEmitter<MessageSendConfig>();
  messageConfig: MessageSendConfig = new MessageSendConfig();

  @Input() availableRecipients: SendMessageReceipients = { clients: [], franchises: [], roles: [] };
  selectedFranchises = signal<number[]>([]);

  filteredClients = computed(() => {
    const recipients = this.availableRecipients;
    const franchiseIds = this.selectedFranchises();
    if (!recipients.clients || recipients.clients.length === 0) {
      return [];
    }
    if (!franchiseIds || franchiseIds.length === 0) {
      return recipients.clients;
    }
    return recipients.clients.filter(client =>
      franchiseIds.includes(client.franchiseId)
    );
  });

  constructor (private commService: CommService, private notification: NotificationService, private destroyRef: DestroyRef) {}


public onFranchiseChange(selectedIds: number[]): void {
  if (selectedIds.includes(-1)) {
    this.selectedFranchises.set(this.availableRecipients.franchises.map(f => f.id));
    this.messageConfig.franchiseIds = this.selectedFranchises();
    this.onChange();
  } else {
    this.selectedFranchises.set(selectedIds);
    this.messageConfig.franchiseIds = selectedIds;
    this.checkClientSelection();
    this.onChange();
  }
}

public onClientChange(selectedIds: number[]): void {
    if (selectedIds.includes(-1)) {
      this.messageConfig.clientIds = this.filteredClients().map(c => c.id);
    } else {
      this.messageConfig.clientIds = selectedIds;
    }
    this.onChange();
  } 

public onRoleChange(selectedIds: number[]): void {
    if (selectedIds.includes(-1)) {
      this.messageConfig.roleIds = this.availableRecipients.roles.map(r => r.id);
    } else {
      this.messageConfig.roleIds = selectedIds;
    }
    this.onChange();
  }

private onChange(): void {
    this.sendMessageConfig.emit(this.messageConfig);
  }

public clearAllSelections(): void {
    this.messageConfig.franchiseIds = [];
    this.selectedFranchises.set([]);
    this.messageConfig.clientIds = [];
    this.messageConfig.roleIds = [];
    this.sendMessageConfig.emit({
      franchiseIds: [],
      clientIds: [],
      roleIds: []
    });
  }

private checkClientSelection(){
    if (this.messageConfig.clientIds && this.messageConfig.clientIds.length > 0) {
      for (const client of this.messageConfig.clientIds){
        if (!this.filteredClients().some(c => c.id === client)) {
          this.messageConfig.clientIds = this.messageConfig.clientIds.filter(c => c !== client);
        }
      }
    }
  }
}